<template>
  <div>
    <b-form-group
      :label="label"
      :state="state"
    >
      <template
        v-if="label"
        v-slot:label
      >
        {{ label }}
        <span
          v-if="required"
          class="text-danger"
        >
          (*)
        </span>
      </template>
      <v-select
        id="invoice"
        v-model="invoice"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :get-option-label="(option) => `${option.code} ${Number(option.remain).toLocaleString()}`"
        :options="invoices"
        :placeholder="t('Hóa đơn')"
        :disabled="student == null || !enable"
        @input="valueChanged"
        @click="onClick"
        @search="onSearchResult"
      >
        <template #option="{ code,remain, ...remainData }">
          {{ code }} {{ remainData.student ? remainData.student.name : '' }}
          <br>
          <cite>{{ Number(remain).toLocaleString() }}</cite>
        </template>

        <!-- eslint-disable-next-line vue/no-unused-vars  -->
        <template #no-options="{ search, searching, loading }">
          {{ t('Không có dữ liệu') }}
        </template></v-select>
      <small class="text-danger">{{ error }}</small>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue';
import vSelect from 'vue-select';
import useJwt from '@/auth/jwt/useJwt';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

export default {
  components: {
    BFormGroup,
    vSelect,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    school: {
      type: Object,
      default: null,
    },
    class: {
      type: Object,
      default: null,
    },
    student: {
      type: Object,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    defaultValue: {
      type: Object,
      default: null,
    },

    enable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      invoice: this.defaultValue,
      invoices: [],
      timer: null,
    };
  },
  watch: {
    class() {
      this.invoice = null;
      this.valueChanged();
      this.fetchInvoices('');
    },
    school() {
      this.invoice = null;
      this.valueChanged();
      this.fetchInvoices('');
    },
    student() {
      this.invoice = null;
      this.valueChanged();
      this.fetchInvoices('');
    },
  },
  created() {
    this.fetchInvoices('');
  },
  methods: {
    valueChanged() {
      this.$emit('input', this.invoice);
    },
    fetchInvoices(searchTerm, loading) {
      if (loading) {
        loading(true);
      }
      const filter = { status: 2, approve: true };

      if (this.school && this.school.id > 0) {
        filter.schoolId = this.school.id;
      }
      if (this.class && this.class.id > 0) {
        filter.classId = this.class.id;
      }
      if (this.student && this.student.id > 0) {
        filter.studentId = this.student.id;
      }
      useJwt.getInvoices({ filter, perPage: 20, searchTerm: searchTerm || '' }).then(res => {
        this.invoices = res.data.items;
        if (loading) {
          loading(false);
        }
      });
    },
    onSearchResult(searchTerm, loading) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.fetchInvoices(searchTerm, loading);
      }, 800);
    },
    onItemCreated(newItem) {
      this.invoice = newItem;
      this.valueChanged();
    },
    onClick() {

    },
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@/assets/scss/vue-select.scss';
.list-header {
    padding: $options-padding-y $options-padding-x;
      color: $secondary;

    &:hover {
      background-color: rgba($success, 0.12);
    }
}
</style>
